import { BCSlider, ISliderProps } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import InputControl from '../../base/InputControl';
import { ISliderProperties } from './entities/ISliderProperties';
import { IPropertyField } from '../../../../entities/common';
import { filterFields } from '../../helper';

export default class Slider extends InputControl<number> {
	step: number;
	min: number;
	max: number;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Slider;

		this.step = 1;
		this.min = 0;
		this.max = 100;
		this.value = 0;

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.triggerValueChanged(Number(value));
		});
	}

	__loadProperties(data: ISliderProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.step = data.step;
		this.__proxyChanged.min = data.min;
		this.__proxyChanged.max = data.max;
	}

	private triggerValueChanged(value: number) {
		this.__proxyChanging.value = value;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...filterFields(fields, ['required']),
			{
				name: 'value',
				type: 'number'
			},
			{
				name: 'step',
				type: 'number'
			},
			{
				name: 'min',
				type: 'number'
			},
			{
				name: 'max',
				type: 'number'
			}
		];
	}

	__getComponentData(): ISliderProps & IDictionary<any> {
		return {
			...super.__getComponentData(),
			step: this.step,
			min: this.min,
			max: this.max
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<BCSlider
				step={this.step}
				disabled={this.__isDisabled()}
				onChange={this.triggerValueChanged.bind(this)}
				min={this.min || 0}
				max={this.max || 0}
				value={this.value}
				style={this.style}
				readOnly={this.__isReadOnly()}
				getTooltipPopupContainer={this.__form.__getShadowRootContainer}
			/>
		);
	}
}
